import { useSearchParams } from 'react-router';

import { getStatementImage } from '../api/StatementsService';
import ImageViewer from '../components/common/ImageViewer';

export default function StatementImage() {
  const [searchParams] = useSearchParams();

  return (
    <ImageViewer
      fetchImageFile={getStatementImage(!!searchParams.get('annotated'))}
      title="Statement file"
    />
  );
}
